import { Component, OnInit, Output, EventEmitter, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { HttpService } from '../../services/http.service';

@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.scss']
})
export class FeedbackComponent implements OnInit {

  @Output() closeClick = new EventEmitter();
  rating = '5';
  errorNotification = false;
  messageNotificationEmail = '';
  messageNotificationComment = '';

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private httpService: HttpService
  ) { }

  ngOnInit() {
  }

  closeFeedback() {
    this.closeClick.emit();
  }

  changeEmotion(value) {
    if (isPlatformBrowser(this.platformId)) {
      this.rating = value;
      let list, emotion, emotionSrc;
      list = document.getElementsByClassName('list-emotion')[0].getElementsByTagName('li');
      emotion = list[value - 1].getElementsByTagName('img')[0];
      emotionSrc = emotion.getAttribute('src');
      for (let i = 0; i < list.length; i++) {
        if (i !== value - 1) {
          list[i].getElementsByTagName('img')[0]
          .setAttribute('src', list[i].getElementsByTagName('img')[0].getAttribute('src').replace('_on', '_off'));
        }
      }
      if (emotionSrc.indexOf('_off') > 0) {
        emotion.setAttribute('src', emotionSrc.replace('_off', '_on'));
      }
    }
  }

  sendFeedback() {
    if (isPlatformBrowser(this.platformId)) {
      const compareEmail = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
      let email, comment;
      let flag = true;
      email = (<HTMLInputElement>document.getElementById('email')).value;
      comment = (<HTMLInputElement>document.getElementById('comment')).value;
      if (email === '' || compareEmail.test(String(email).toLowerCase()) === false) {
        this.messageNotificationEmail = 'Invalid email address';
        this.errorNotification = true;
        flag = false;
      } else {
        this.messageNotificationEmail = '';
      }
      if (comment.trim() === '') {
        this.messageNotificationComment = 'Please enter your feedback';
        this.errorNotification = true;
        flag = false;
      } else {
        this.messageNotificationComment = '';
      }
      if (flag){
        this.errorNotification = false;
        const feedback = { rating: this.rating, email: email, comment: comment };
        this.httpService.sendFeedback(feedback)
            .subscribe((data) => {
              this.closeClick.emit();
        });
      }
    }
  }

}
